<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <!-- Header компонент -->
    <Header />

    <!-- Основной контент с сайдбаром -->
    <div class="flex-1 flex">
      <!-- Sidebar -->
      <aside class="hidden lg:block">
        <div class="sticky top-0 h-screen">
          <DocsSidebar />
        </div>
      </aside>

      <!-- Mobile sidebar toggle -->
      <div class="lg:hidden fixed top-20 left-4 z-40">
        <button
          class="p-2 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          @click="toggleMobileSidebar"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>

      <!-- Mobile sidebar overlay -->
      <div
        v-if="isMobileSidebarOpen"
        class="lg:hidden fixed inset-0 z-50 flex"
        @click="closeMobileSidebar"
      >
        <div class="fixed inset-0 bg-black bg-opacity-50" @click="closeMobileSidebar"></div>
        <div class="relative bg-white" @click.stop>
          <button
            class="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600"
            @click="closeMobileSidebar"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          <DocsSidebar />
        </div>
      </div>

      <!-- Main content area -->
      <main class="flex-1 min-w-0">
        <slot />
      </main>
    </div>

    <!-- Footer компонент -->
    <Footer />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import DocsSidebar from '@/components/DocsSidebar.vue'

const isMobileSidebarOpen = ref(false)

function toggleMobileSidebar() {
  isMobileSidebarOpen.value = !isMobileSidebarOpen.value
}

function closeMobileSidebar() {
  isMobileSidebarOpen.value = false
}
</script> 